var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1899_11387)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5217 15.9145C18.7395 15.2958 19.1694 14.7741 19.7352 14.4417C20.301 14.1094 20.9662 13.9879 21.6131 14.0988C22.2599 14.2097 22.8466 14.5458 23.2692 15.0476C23.6919 15.5493 23.9232 16.1844 23.9222 16.8403C23.9222 18.6919 21.1432 19.6176 21.1432 19.6176V20.7594M21.1791 23.8243H21.1914M20.9938 29.5C26.7962 29.5 31.5 24.799 31.5 19C31.5 13.201 26.7962 8.5 20.9938 8.5C15.1914 8.5 10.4876 13.201 10.4876 19C10.4876 20.1735 10.6802 21.3021 11.0356 22.3558C11.1693 22.7524 11.2362 22.9506 11.2482 23.1029C11.2602 23.2534 11.2512 23.3588 11.2139 23.5051C11.1762 23.6531 11.093 23.8071 10.9265 24.1151L8.90475 27.855C8.61637 28.3885 8.47218 28.6552 8.50445 28.8611C8.53256 29.0404 8.63815 29.1982 8.79318 29.2928C8.97117 29.4013 9.27291 29.3701 9.87639 29.3078L16.2061 28.6538C16.3978 28.634 16.4936 28.6241 16.581 28.6275C16.6669 28.6308 16.7276 28.6388 16.8114 28.6581C16.8965 28.6778 17.0037 28.719 17.2179 28.8015C18.3897 29.2527 19.6629 29.5 20.9938 29.5Z",
    stroke: "#4D4D4D",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1899_11387"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H36C38.2091 0 40 1.79086 40 4V36C40 38.2091 38.2091 40 36 40H4C1.79086 40 0 38.2091 0 36V4Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.af1923818a811a041251c04e0025d0b9.svg";
export { ForwardRef as ReactComponent };